import { buildLegend } from "@features/sales-v3/utils/tooltip";

export const DATASET_ACTUAL_LABEL = "Actual";
export const DATASET_ACTUAL_COLOR = "#5CBF64";
export const DATASET_ACTUAL_LEGEND = buildLegend(
  {
    borderColor: DATASET_ACTUAL_COLOR,
    backgroundColor: DATASET_ACTUAL_COLOR,
    borderDash: [],
    pointRadius: 3,
  },
  false,
);

export const DATASET_PREDICTION_LABEL = "Predicted";
export const DATASET_PREDICTION_COLOR = "#7081FF";
export const DATASET_PREDICTION_LEGEND = buildLegend(
  {
    borderColor: DATASET_PREDICTION_COLOR,
    backgroundColor: DATASET_PREDICTION_COLOR,
    borderDash: [],
    pointRadius: 3,
  },
  false,
);

export const DATASET_PREDICTION_RANGE_LABEL = "Predicted range";
export const DATASET_PREDICTION_RANGE_COLOR = "#D5D8FF";
export const DATASET_PREDICTION_RANGE_LEGEND = buildLegend(
  {
    borderColor: DATASET_PREDICTION_RANGE_COLOR,
    backgroundColor: DATASET_PREDICTION_RANGE_COLOR,
    borderDash: [],
  },
  true,
);
